'use client';

import { X } from 'lucide-react';

interface AlertModalProps {
  /**
   * Modal visibility state
   */
  isOpen: boolean;
  
  /**
   * Function to close the modal
   */
  onClose: () => void;
  
  /**
   * Modal title
   */
  title: string;
  
  /**
   * Modal message/content
   */
  message: string;
  
  /**
   * Text for the button
   */
  buttonText?: string;
}

export function AlertModal({
  isOpen,
  onClose,
  title,
  message,
  buttonText = 'OK'
}: AlertModalProps) {
  if (!isOpen) return null;


  return (
    <div 
      className="bg-white rounded-lg shadow-lg w-full max-w-md"
    >
      {/* Header */}
      <div className="flex items-center justify-between p-6 pb-4">
        <h2 id="alert-modal-title" className="text-xl font-semibold text-gray-900">{title}</h2>
        <button
          onClick={onClose}
          aria-label="Close dialog"
          className="rounded-full p-1.5 transition-colors hover:bg-gray-100"
          style={{ color: '#3b6fc8' }}
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Content */}
      <div className="px-6 pb-6">
        <p className="text-gray-600">{message}</p>
      </div>

      {/* Footer */}
      <div className="px-6 pb-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 text-black font-medium transition-all duration-150 rounded-md"
            style={{
              backgroundColor: '#f8b908',
              boxShadow: '0 2px 0 #c4930a',
            }}
          >
            {buttonText}
          </button>
        </div>
    </div>
  );
}